module.exports = __webpack_public_path__ + "static/media/015.eb2f4dee.jpg";